jQuery(document).ready(function ($) {
        AOS.init({
        duration: 2000, // animation duration in ms
        once: false,     // whether animation happens only once
        offset: 100,    // offset (in px) from the original trigger point
    });

});
